export default __webpack_public_path__ + "static/media/upload.32b51a3a.svg";